module.exports = __webpack_public_path__ + "static/loyalty-scene.c33dfe7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/loyalty-scene.jpg
// module id = 672
// module chunks = 35783957827783